import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('round/:any', form);
Router.get('round', index);
